import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';

import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';
import { OutlineLabel } from '../../../../../../../atoms/OutlineLabel';
import BooksTimeItem from '../../texts/BooksTimeItem';

import css from './BooksSelectTimeEvent.module.scss';

interface Props {
  postable: boolean;
  startTime: string;
  endTime: string;
  vacancy: number;
  showVacancy: boolean;
  attendees: number;
  value: string | number;
  checked: boolean;
  waitingListProvided: boolean;
  setNotification?: boolean;
  onChange?: (e: React.ChangeEvent) => void;
  onClickSetNotification?: (e: React.MouseEvent) => void;
}

const BooksSelectTimeEvent = ({
  postable,
  startTime,
  endTime,
  vacancy,
  showVacancy,
  value,
  checked,
  attendees,
  waitingListProvided,
  setNotification,
  onChange,
  onClickSetNotification,
}: Props) => {
  const intl = useIntl();
  const classes = classNames(css.BooksSelectTimeEvent);
  const timeClasses = classNames(
    css.BooksSelectTimeEvent__Time,
    vacancy < attendees || vacancy < 1 ? css.isDisabled : '',
  );
  const notificationClasses = classNames(
    css.BooksSelectTimeEvent__Notification,
    css.isSetNotification,
  );
  const labelClasses = classNames(css.BooksSelectTimeEvent__Label, {
    [css.isSoldOut]: !vacancy,
  });

  return (
    <div className={classes}>
      <CheckInput
        type={InputType.Checkbox}
        name="event-select-time"
        checked={checked}
        onChange={onChange}
        disabled={vacancy < attendees || vacancy < 1}
        labelPosition="FlexWrap"
        value={value}
      >
        <BooksTimeItem
          startTime={startTime}
          endTime={endTime}
          className={timeClasses}
        />
        <div className={css.BooksSelectTimeEvent__Labels}>
          {vacancy > attendees ? (
            showVacancy && (
              <OutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksSelectTimeEvent__Label}
              />
            )
          ) : vacancy < 1 ? (
            <OutlineLabel
              label={intl.formatMessage({
                id: 'merchants.services.status.soldOut',
              })}
              className={labelClasses}
            />
          ) : (
            showVacancy && (
              <OutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksSelectTimeEvent__Label}
              />
            )
          )}
          {setNotification
            ? vacancy < 1 &&
              waitingListProvided && (
                <span className={notificationClasses}>
                  {intl.formatMessage({
                    id: 'books.notification.notificationSet',
                  })}
                </span>
              )
            : vacancy < 1 &&
              waitingListProvided && (
                <button
                  type="button"
                  value={value}
                  disabled={!postable}
                  className={css.BooksSelectTimeEvent__Notification}
                  onClick={onClickSetNotification}
                >
                  {intl.formatMessage({ id: 'books.notification.getNotified' })}
                  {!postable && (
                    <span className={css.BooksSelectTimeEvent__Loading} />
                  )}
                </button>
              )}
        </div>
      </CheckInput>
    </div>
  );
};

export default BooksSelectTimeEvent;
